import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
import { connectHits } from 'react-instantsearch-dom'
import { Hit } from '../algolia/components/index'

interface Props {
  hits: Hit[]
  topicId: string
  widgetTitle: string
  totalItemCount: number
}

const getIconClass = (hit: Hit) => {
  if (hit.has_answer) {
    return 'icon--checkmark qa-icon-answered'
  }
  if (hit.content_type === 'question') {
    return 'icon--question qa-icon-question'
  }
  return null
}

export const RelatedTopicsList: FunctionalComponent<Props> = (props) => {
  const { hits, topicId, widgetTitle, totalItemCount } = props
  const hitsWithoutCurrent = hits
    .filter((hit) => hit.id !== parseInt(topicId))
    .slice(0, totalItemCount)

  if (!hitsWithoutCurrent.length) {
    return null
  }

  return (
    <div className='box__content widget box__pad widget--related-topics'>
      {Boolean(widgetTitle) && (
        <h3 className='widget-title related-topics__widget-title'>{widgetTitle}</h3>
      )}
      <ul class='simple-topic-list'>
        {hitsWithoutCurrent.map((hit, index) => {
          const iconClass = getIconClass(hit)
          return (
            <li key={index} className='related-topics__topic simple-topic-list--item'>
              <h6 className='related-topics__topic-title simple-topic-list--title'>
                <a className='link link--topic' href={hit.topic_url}>
                  {hit.title}
                </a>
                {Boolean(iconClass) && (
                  <span className={classnames('icon', 'icon--replace', 'icon--round', iconClass)}>
                    icon
                  </span>
                )}
              </h6>
              <a href={`/fid-${hit.forum}`} class='text--meta'>
                {hit.forum_title}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const RelatedTopicsListContainer = connectHits(RelatedTopicsList)

export default RelatedTopicsListContainer
